import React, { useEffect } from "react";
import Icone from "./HorsConnexion/Icone";
import "./HorsConnexion/hors-connexion.scss";

/**
 * Règles du mot de passe cochées en direct, avec la jauge de la charte (même
 * rendu que les écrans hors connexion). Mêmes props et même contrat
 * qu'avant : `setCanSave(true)` quand toutes les règles demandées sont
 * respectées.
 */
const PasswordControl = ({
  minLength = 0,
  minLowercase = 0,
  minUppercase = 0,
  minSpecial = 0,
  minNumber = 0,
  password,
  setCanSave,
  style,
}) => {
  const compter = (motif) => (password.match(motif) || []).length;
  const pluriel = (n, mot) => `${n} ${mot}${n > 1 ? "s" : ""}`;
  const regles = [
    minLength > 0 && { cle: "longueur", libelle: `${minLength} caractères minimum`, ok: password.length >= minLength },
    minLowercase > 0 && { cle: "minuscules", libelle: pluriel(minLowercase, "minuscule"), ok: compter(/[a-z]/g) >= minLowercase },
    minUppercase > 0 && { cle: "majuscule", libelle: pluriel(minUppercase, "majuscule"), ok: compter(/[A-Z]/g) >= minUppercase },
    minNumber > 0 && { cle: "chiffre", libelle: pluriel(minNumber, "chiffre"), ok: compter(/[0-9]/g) >= minNumber },
    minSpecial > 0 && {
      cle: "special",
      libelle: `${minSpecial} caractère${minSpecial > 1 ? "s" : ""} spéci${minSpecial > 1 ? "aux" : "al"}`,
      ok: compter(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g) >= minSpecial,
    },
  ].filter(Boolean);
  const nbOk = regles.filter((r) => r.ok).length;
  const conforme = nbOk === regles.length;
  // Jauge sur 4 : vide, puis proportionnelle aux règles respectées, 3 conforme, 4 conforme et long.
  let niveau = password.length === 0 ? 0 : Math.min(3, Math.round((nbOk / Math.max(regles.length, 1)) * 3));
  if (password.length > 0 && conforme) niveau = password.length >= 14 ? 4 : 3;

  useEffect(() => {
    // Règle de l'ancien composant conservée : minLowercase, minUppercase et
    // minNumber conditionnent l'enregistrement (minSpecial ne s'affichait qu'à titre indicatif).
    setCanSave(regles.filter((r) => r.cle !== "special").every((r) => r.ok));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password]);

  return (
    <div className="hc hc--regles" style={style}>
      <div className="jauge" data-niveau={niveau} aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </div>
      <ul className="regles" aria-label="Règles du mot de passe">
        {regles.map((r) => (
          <li key={r.cle} className={r.ok ? "ok" : ""} data-regle={r.cle}>
            <span className="puce">
              <Icone nom="coche" epaisseur={3.5} />
            </span>
            {r.libelle}
            <span className="sr-only">{r.ok ? " : respectée" : " : à respecter"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordControl;
